export type SupportedLanguage = 'ru' | 'en';

export function normalizeLanguage(value?: string | null): SupportedLanguage | null {
  const language = value?.trim().toLowerCase().split(/[-_]/)[0];
  return language === 'ru' || language === 'en' ? language : null;
}

export function resolveLanguage(stored?: string | null, browser?: string | null): SupportedLanguage {
  return normalizeLanguage(stored) || normalizeLanguage(browser) || 'ru';
}
